import React from 'react';
import { Container } from 'react-bootstrap';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsAndCondition = () => {
    return (
        <>
            <Header />
            <section className="terms-section">
                <Container className="terms-container">
                    <h4>Terms and Conditions</h4>

                    <div className="terms-content">
                        <h5>1. Introduction</h5>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus a vehicula ex. Phasellus nulla sapien, luctus eget augue ut, aliquam iaculis diam. Phasellus nunc dolor, ornare a fermentum sit amet, ultrices nec leo. Vestibulum leo nunc, ullamcorper at nulla ut, dignissim efficitur nisl. Nam porttitor luctus luctus. Interdum et malesuada fames ac ante ipsum primis in faucibus. Mauris nec nibh quis massa vehicula egestas vel sed ligula.
                            
                            
                        </p>

                        <h5>2. Acceptance of Terms</h5>
                        <p>
                        Cras urna augue, posuere nec fringilla nec, mollis nec erat. Praesent vel libero a est ultrices bibendum et quis ipsum. Cras metus purus, sollicitudin eu gravida eget, varius ut dolor. Quisque placerat nec nisl vel pretium. Cras lobortis sagittis cursus. Etiam facilisis libero non purus tincidunt, sed mollis sapien ornare. Suspendisse eget nibh sed tellus scelerisque pulvinar vitae quis lorem. Suspendisse sit amet aliquet justo.
                        </p>

                        <h5>3. Privacy Policy</h5>
                        <p>
                        Ut ex nisl, efficitur et mollis vitae, ornare nec enim. Donec eleifend lorem sed orci consequat, quis facilisis orci mollis. Donec sit amet mi accumsan, commodo odio vel, varius libero. Nulla imperdiet feugiat sapien at ullamcorper. Donec egestas purus at elit bibendum, quis scelerisque ligula maximus. Praesent eu arcu nec nisl fermentum dignissim. In hac habitasse platea dictumst. In quis rhoncus lectus, id gravida felis.
                        </p>

                        
                    </div>
                </Container>
            </section>
            <Footer />
        </>
    );
};

export default TermsAndCondition;
